import React, { useState, Fragment, useEffect } from 'react';
import { Row, Input, Label, Button, FormGroup, Modal, ModalHeader, ModalFooter, ModalBody, Table } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { API_CurrencyManager } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
export default function CurrencyManager({ visible, toggle }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [inputFields, setInputFields] = useState({
        fromCurrency: "",
        toCurrency: "",
        rate: "",
        status: "Active"
    });
    const [id, setid] = useState(null);
    const [isList, setIsList] = useState(false);
    useEffect(() => {
        Loaddata();
    }, []);
    const Loaddata = () => {
        AxiosAPI({
            method: 'get',
            url: `${API_CurrencyManager}/list`,
        }).then((res) => {
            setCurrencyList(res.data);
        })
    }
    const edit = (data) => {
        setid(data.id);
        setInputFields({
            fromCurrency: data.fromCurrency,
            toCurrency: data.toCurrency,
            rate: data.rate,
            status: data.status
        });
        setIsList(true);
    }
    const submit = () => {
        var databody = {
            ...inputFields
        }
        if (id !== null) {
            databody.id = id;
        }
        AxiosAPI({
            method: 'post',
            url: `${API_CurrencyManager}/Create`,
            data: databody,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                Loaddata();
                toggle()
            }
        }
        );
    }
    return (
        <Modal isOpen={visible}
            toggle={() => toggle()} style={{ borderRadius: '10px' }}>
            <ModalHeader toggle={() => toggle()}>Currency Manager</ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx md="12" className="mb-2">
                        <Table className="b-1" striped>
                            <thead>
                                <tr>
                                    <th>From Currency</th>
                                    <th>To Currency</th>
                                    <th>Rate</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {currencyList.length > 0 && currencyList.map((elem) =>
                                    <tr>
                                        <td>{elem.fromCurrency}</td>
                                        <td>{elem.toCurrency}</td>
                                        <td>{elem.rate}</td>
                                        <td> <Button color='primary' size="xs" onClick={() => edit(elem)}>Edit</Button></td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Colxx>
                </Row>
                <Row>
                    <Colxx md="12" className="mb-2">
                        <Button color='primary' size="xs" onClick={() => setIsList(true)}>+ Add Currency</Button>
                    </Colxx>
                </Row>
                {isList &&
                    <Row>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label>From Currency</Label>
                                <Input
                                    type="text"
                                    value={inputFields.fromCurrency}
                                    onChange={(e) => setInputFields({ ...inputFields, fromCurrency: e.target.value })}
                                ></Input>
                            </FormGroup>
                        </Colxx>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label>To Currency</Label>
                                <Input
                                    type="text"
                                    value={inputFields.toCurrency}
                                    onChange={(e) => setInputFields({ ...inputFields, toCurrency: e.target.value })}
                                ></Input>
                            </FormGroup>
                        </Colxx>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label>Rates</Label>
                                <Input
                                    type="text"
                                    value={inputFields.rate}
                                    onChange={(e) => setInputFields({ ...inputFields, rate: e.target.value })}
                                ></Input>
                            </FormGroup>
                        </Colxx></Row>}
            </ModalBody>
            <ModalFooter>
                <Button color='primary' onClick={() => submit()}>Submit</Button>
                <Button className="ml-2" onClick={() => toggle()}>Close</Button>
            </ModalFooter>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Modal>)
}